import { Validator } from 'vee-validate';
import authenticationService from '../services/authentication.service';

export default {
  data() {
		return {
			uniqueLoginErrorMessage: 'login taken'
		}
	},
  methods: {
    async isLoginUnique(value) {
      let isLoginUnique = (await authenticationService.isLoginUnique(value)).isValid;
      let message = !isLoginUnique ? this.uniqueLoginErrorMessage : '';
      return {
        valid: isLoginUnique,
        data: { message },
      };
    },
  },
  mounted() {
    Validator.extend('unique-login', {
      validate: this.isLoginUnique,
      getMessage: (field, params, data) => data.message,
    });
  },
};



// WEBPACK FOOTER //
// ./_common/mixins/unique-login.validation-rule.mixin.js